// Client-side filter helper for Quote / SO / PO / PR / GRN registers.
// Iter-92 · Phase 1

export const STATUS_BUCKETS = [
  { key: "all",       label: "All" },
  { key: "open",      label: "Open" },
  { key: "partial",   label: "Partially closed" },
  { key: "closed",    label: "Closed" },
  { key: "cancelled", label: "Cancelled" },
];

// Map each doc type's raw statuses → our 4 buckets.
// The lists below are exhaustive of what the backend currently emits.
export const STATUS_MAP = {
  pr: {
    open:      ["open", "draft", "pending"],
    partial:   ["partially_converted", "partial"],
    closed:    ["converted", "closed", "completed"],
    cancelled: ["cancelled", "rejected"],
  },
  po: {
    open:      ["open", "approved", "pending", "draft"],
    partial:   ["partially_received", "partial", "partially_billed"],
    closed:    ["billed", "closed", "completed", "received"],
    cancelled: ["cancelled", "rejected"],
  },
  grn: {
    open:      ["open", "pending", "draft", "provisional"],
    partial:   ["partial", "partially_billed"],
    closed:    ["billed", "closed", "final"],
    cancelled: ["cancelled", "rejected"],
  },
  quote: {
    open:      ["open", "draft", "sent", "pending"],
    partial:   ["partially_converted"],
    closed:    ["converted", "invoiced", "closed", "accepted"],
    cancelled: ["cancelled", "rejected", "expired"],
  },
  so: {
    open:      ["open", "confirmed", "draft", "pending"],
    partial:   ["partially_invoiced", "partial", "partially_dispatched"],
    closed:    ["invoiced", "closed", "completed", "dispatched"],
    cancelled: ["cancelled", "rejected"],
  },
};

export function applyFilters(rows, docKind, { status, from, to, party }) {
  if (!Array.isArray(rows)) return [];
  return rows.filter((r) => {
    // Date filter
    if (from && r.date && r.date < from) return false;
    if (to && r.date && r.date > to) return false;
    // Party filter (customer or vendor id)
    if (party) {
      const pid = r.vendor_id || r.customer_id;
      if (pid !== party) return false;
    }
    // Status bucket filter
    if (status && status !== "all") {
      const raw = String(r.status || "").toLowerCase();
      const allowed = (STATUS_MAP[docKind]?.[status]) || [];
      if (!allowed.includes(raw)) return false;
    }
    return true;
  });
}

// Simple aggregate for header pill: {open, partial, closed, cancelled, total}
export function bucketCounts(rows, docKind) {
  const c = { all: rows.length, open: 0, partial: 0, closed: 0, cancelled: 0 };
  for (const r of rows) {
    const raw = String(r.status || "").toLowerCase();
    for (const b of ["open", "partial", "closed", "cancelled"]) {
      if ((STATUS_MAP[docKind]?.[b] || []).includes(raw)) c[b]++;
    }
  }
  return c;
}
